import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  form: {
    width: '540px',
    padding: '0 0 30px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '0 10px 30px',
      display: 'flex',
      flexDirection: 'column'
    },
  },
  fields: {
    paddingBottom: '25px',
    marginBottom: '30px',
    borderBottom: '1px solid #e2ebf6',
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column'
    },
  },
}));
